import React, { memo } from 'react';
import { ShieldCheck, Lock, Cpu, EyeOff } from 'lucide-react';
export function Security() {
  const securityFeatures = [{
    icon: <Lock className="w-6 h-6 text-green-600" data-id="element-351" />,
    title: 'Encrypted at Rest',
    description: 'Your API keys are encrypted using industry-standard AES-256 before they ever touch our database.'
  }, {
    icon: <Cpu className="w-6 h-6 text-green-600" data-id="element-352" />,
    title: 'In-Memory Decryption',
    description: 'Decryption only happens in volatile memory at the edge location during the request lifecycle.'
  }, {
    icon: <EyeOff className="w-6 h-6 text-green-600" data-id="element-353" />,
    title: 'No Plain Text Storage',
    description: 'We never store your keys in plain text. Not in logs, not in backups, not in our database. Period.'
  }];
  return <section className="py-24 bg-white" data-id="element-354">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-355">
        <div className="text-center mb-16" data-id="element-356">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-50 text-green-700 text-sm font-medium mb-6" data-id="element-357">
            <ShieldCheck className="w-4 h-4" data-id="element-358" />
            <span data-id="element-359">Enterprise-grade security</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-360">
            Secure by default
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-361">
            We take security seriously. Your infrastructure is only as strong as
            its weakest link, which is why we've built TokenGates with a
            security-first architecture.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-362">
          {securityFeatures.map((feature, i) => <div key={i} className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:border-green-200 transition-colors group" data-id="element-363">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform" data-id="element-364">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-365">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-366">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}